import React, { useContext, useEffect, useState } from "react";
import FirstVendor from "./FirstVendor/FirstVendor";
import SecondVendor from "./SecondVendor/SecondVendor";
import RateAndReview from "./RateAndReview/RateAndReview";

import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getProductDetail } from "../../utils/apis/Product/Product";
import { getCartCheck } from "../../utils/apis/addToCart/addToCart";
import { Context } from "../../utils/context";
import Cookies from "js-cookie";
const VendorPage = () => {
  const { signin, variant, subvariant } = useContext(Context);

  const navigate = useNavigate();
  const [product, setProduct] = useState();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("product_id");

  const product_id = token ? atob(token) : null;

  const [cartStatus, setCartStatus] = useState(false);
  const [cartData, setCartData] = useState();
  const [variantId, setVariantId] = useState("");


  const storedProductId = product_id;

  const getProduct = async () => {
    if (storedProductId) {
      const res = await getProductDetail(storedProductId);
      if (res?.success) {
        await setProduct(res?.data);
        var response;

        if (Cookies.get("boomer_bucks_security")) {
          const data = {
            product_id: storedProductId,
            variant_id: variant?.id,
            m_variant_id: subvariant?.id,
          };

          response = await getCartCheck(data);
        } else {
          const data = {
            product_id: storedProductId,
            variant_id: variant?.id,
            m_variant_id: subvariant?.id,
          };
          response = await getCartCheck(data);
        }

        if (response?.success) {
          if (
            response?.cartItem?.variant_id === variant?.id ||
            response?.cartItem?.m_variant_id ===
              subvariant?.[0]?.product_multiple_variants
              ? subvariant?.[0]?.product_multiple_variants?.id
              : subvariant?.id
          ) {
            await setCartStatus(true);
          } else {
            // await setCartStatus(false);
          }
          await setCartData(response?.cartItem);
        }
      }
    } else {
      // navigate("/");
    }
  };
  useEffect(() => {
    getProduct();
  }, [product_id]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <FirstVendor
        product={product}
        cartStatus={cartStatus}
        setCartStatus={setCartStatus}
        cartData={cartData}
        getProduct={getProduct}
        setVariantId={setVariantId}
        setCartData={setCartData}
      />
      {signin && <RateAndReview product={product} />}

      <SecondVendor
        heading="You may also like"
        product={product}
        storedProductId={storedProductId}
      />
    </>
  );
};

export default VendorPage;
